import { axios } from "../../config/axios";

export const brandsMarketplaceAPI = {
    /**
   * GET All brand displays for each row by state, previously_sponsored, & in_store
   * @constructor
   * @returns {object} {
   * "states":[{
   *    "state_name":[{
   *        "id":23,
   *        "display_name":"Awesome Display",
   *        "image":"https://cdn.springbig.cloud/development/branddisplay/52849e58/5d1c/4d66/82a0/6841c59365f8/thumb/Hapy-monday-memes.jpeg",
   *        "advertiser_created_at":"2021-06-21 15:23:49 +00:00"}]
   *    }],
   * "previously_sponsored":[{
   *    "id":23,
   *    "display_name":"Awesome Display",
   *    "image":"https://cdn.springbig.cloud/development/branddisplay/52849e58/5d1c/4d66/82a0/6841c59365f8/thumb/Hapy-monday-memes.jpeg",
   *    "advertiser_created_at":"2021-06-21 15:23:49 +00:00"
   * }],
   * "in_store":[{
   *    "id":23,
   *    "display_name":"Awesome Display",
   *    "image":"https://cdn.springbig.cloud/development/branddisplay/52849e58/5d1c/4d66/82a0/6841c59365f8/thumb/Hapy-monday-memes.jpeg","advertiser_created_at":"2021-06-21 15:23:49 +00:00"}
   * ]}
  **/
    getAllBrandDisplays() {
      return axios.get('/api/v3/brand_displays').then((resp) => {
        return resp.data
      });
    },
  /**
   * GET Main Navigation Demo Brand Display
   * @constructor
   * @returns {object} {
   * "name":"brand marketplace",
   * "id":123,
   * "primary_image":{
   *    "id":99,
   *    "url":"https://cdn.springbig.cloud/original/default_demo_image.png",
   *    "thumb":"https://cdn.springbig.cloud/thumb/default_demo_image.png"
   * },
   * "secondary_images":[]
   * }
  **/
  getDemoBrandDisplay() {
    return axios.get('/api/v3/brand_displays/demo_show').then((resp) => {
        return resp.data
    });
  },
  /**
   * GET Individual brand display
   * @constructor
   * @param {number} id - 99.
   * @returns {object} {
    * "id":999,
    * "name":"Burton Brand",
    * "primary_image":{
    *   "id":222,
    *   "url":"https://cdn.springbig.cloud/development/original/Planet_Purp_MMS_1.png",
    *   "thumb":"https://cdn.springbig.cloud/development/thumb/Planet_Purp_MMS_1.png"
    * },
    *   "secondary_images":[{
    *   "id":765,
    *   "url":"https://cdn.springbig.cloud/development/original/Planet_Purp_MMS_1.png",
    *   "thumb":"https://cdn.springbig.cloud/development/thumb/Planet_Purp_MMS_1.png"
    *   }]
    * }
  **/
   getBrandDisplay(brandDisplayId) {
    return axios.get(`/api/v3/brand_displays/${brandDisplayId}`).then((resp) => {
        return resp.data
    });
  },
  /**
  * Retrieves sponsor types for checkbox selection
  * @constructor
  * @returns {array[{object}]} {@param sponsor_request_types:
  *   @param date: created_at: "2022-06-28T14:09:31.662Z"
  *   @param id: 1
  *   @param name: "existing offer"
  *   @param date updated_at: "2022-06-28T14:09:31.662Z"
  * }
  */
  getSponsorTypes() {
    return axios.get('/api/v3/sponsor_request_types')
      .then(resp => resp.data)
  },
  /**
  * Retrieves current total of textable members
  * @constructor
  * @param {object} params: { allowed_sms_count: Number }
  * @returns {object} { count: 45 }
  */
  getSmsCount(params) {
    return axios.get('/api/v3/current_merchant/allowed_sms_count', params)
      .then(resp => resp.data);
  },
  /**
   * Post Brands Marketplace Inventory Requests
   * @constructor
   * @param {object} brandId - { brand_display_id: 99 }
   * @returns {object} {
    * "id":123,
    * "brand_display_id":99,
    * "inventory_requests":33,
    * "last_inventory_request":"2021-06-02T19:45:58.000Z"
   * }
  **/
  postMarketplaceInventory(brandId) {
    return axios.post('/api/v3/marketplace_inventory_requests', brandId, {passthrough: { codes: [400, 422] }})
      .then((resp) => resp.data);
  },
  /**
   * Post Brands Marketplace Sponsor Requests
   * @constructor
   * @param {object} sponsor_request_log_attributes {
   *   @param {number} id: 1,
   *   @param {number} marketplace_sponsor_request_id: 2,
   *   @param {date} start_date: 1-1-2022,
   *   @param {date} end_date: 1-5-2022,
   *   @param {number} suggested_recipient_count: 746,
   *   @param {string} general_notes: test notes,
   *   @param {array} sponsor_request_type_ids: [1,2,3],
   *
    }
   * @returns {object} {
    * "id":123,
    * "brand_display_id":99,
    * "sponsor_requests":33,
    * "last_sponsor_request":"2021-04-02T19:45:58.000Z",
   * }
  **/
  postMarketplaceSponsor(params) {
    const formData = new FormData()

    formData.append("marketplace_sponsor_request[brand_display_id]", params.brandDisplayId)
    formData.append("marketplace_sponsor_request[sponsor_request_log_attributes][start_date]", params.selectedStartDateRange)
    formData.append("marketplace_sponsor_request[sponsor_request_log_attributes][end_date]", params.selectedEndDateRange)
    formData.append("marketplace_sponsor_request[sponsor_request_log_attributes][suggested_recipient_count]", params.hasRecipientCount)
    formData.append("marketplace_sponsor_request[sponsor_request_log_attributes][general_notes]", params.hasGeneralNotes)
    params.sponsorRequestIds.forEach(id => formData.append("marketplace_sponsor_request[sponsor_request_log_attributes][sponsor_request_type_ids][]", id))
    formData.append("marketplace_sponsor_request[attachment_attributes][file]", params.hasImageUploaded)
    formData.append("marketplace_sponsor_request[attachment_attributes][label]", 'sponsor_request_image')


    // "passthrough" allows axios to return 200 if request status code is included inside "codes" array
    return axios.post('/api/v3/marketplace_sponsor_requests', formData, {passthrough: { codes: [422] }})
      .then((resp) => resp.data);
  },
  /**
   * Post Brand Referral
   * @constructor
   * @form {object} form - { brand_name: 'cali buds', contact_name: 'Jack Smith', phone_number: 3213211234, email: 'johnsmith@gmail.com'}
   * @returns {object}
   * "status": 201
  **/
  postBrandReferral(form) {
    return axios.post('/api/v3/brand_referrals', form)
      .then((resp) => resp)
  }
}
